import { render, staticRenderFns } from "./DocumentTemplates.vue?vue&type=template&id=270b8119&scoped=true"
import script from "./DocumentTemplates.vue?vue&type=script&lang=js"
export * from "./DocumentTemplates.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplates.vue?vue&type=style&index=0&id=270b8119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b8119",
  null
  
)

export default component.exports